module.exports = __webpack_public_path__ + "static/media/defaultArchive.8000bca9.png";